module.exports = __webpack_public_path__ + "static/filmov-b53cf356326a0bca66dffc1e3ce5d5c4.svg";